/**
 * The web font faces nearly every page sets text in (see the @font-face rules in
 * styles/base.css), as CSS font shorthands.
 */
export const EARLY_FONTS = [
  '400 1em "Geist"',
  '500 1em "Geist"',
  '600 1em "Geist"',
  '700 1em "Geist"',
  '400 1em "Libre Caslon Text"',
];

/**
 * Starts downloading the web fonts at startup. A browser only fetches a font
 * once some text needs it, and here the first text appears after the layout and
 * content requests have answered — so the fonts were fetched only then, and
 * swapped in over the already rendered page (CLS). Started here, they download
 * alongside those requests, while the page is still a spinner.
 *
 * Deliberately not `<link rel="preload">` in index.html: that would compete with
 * the app bundle for bandwidth before anything can render at all.
 */
export function preloadFonts(fonts: string[] = EARLY_FONTS): void {
  if (typeof document === "undefined" || !document.fonts) return;
  for (const font of fonts) {
    // Only the side effect matters; a failure leaves the fallback in place.
    document.fonts.load(font).catch(() => undefined);
  }
}
